  const root = document.getElementById('wccp-composite-root');
if (!root) {
  console.warn('[WCCP] Root element not found.');
} 